import DateFilter from '@/components/date-filter';
import ManageActionCreanceAssurance from '@/components/comptable/creance/manage-action-creance-assurance'
import store_operation from "@/store/mods/caisse/operations"
import store_assurance from '@/store/mods/parametres/assurance'
import $ from 'jquery'

// Part du forfait mensuel consommée à partir de laquelle la société passe « À surveiller »
export const SEUIL_SURVEILLANCE = 80

/**
 * Qualifie la rentabilité d'une société sous forfait pour le mois de référence.
 * @param {number} conso_mois       Consommation réelle cumulée du mois (part assureur)
 * @param {number|null} forfait_mensuel  Montant forfaitaire mensuel à déposer
 * @param {boolean} forfait_indisponible  Forfaits non chargés depuis la Clinique
 */
export function qualifier_rentabilite(conso_mois, forfait_mensuel, forfait_indisponible) {
    if (forfait_indisponible) {
        return { code: 'indisponible', libelle: 'Forfait indisponible', classe: 'badge-secondary', taux: null, ecart: null }
    }
    const forfait = Number(forfait_mensuel)
    if (!forfait || forfait <= 0) {
        return { code: 'non_configure', libelle: 'Forfait non configuré', classe: 'badge-secondary', taux: null, ecart: null }
    }
    const conso = Number(conso_mois) || 0
    const taux = Math.round((conso / forfait) * 1000) / 10
    const ecart = forfait - conso
    if (conso > forfait) {
        return { code: 'deficitaire', libelle: 'Déficitaire', classe: 'badge-danger', taux, ecart }
    }
    if (taux >= SEUIL_SURVEILLANCE) {
        return { code: 'surveiller', libelle: 'À surveiller', classe: 'badge-warning', taux, ecart }
    }
    return { code: 'rentable', libelle: 'Rentable', classe: 'badge-success', taux, ecart }
}

export default {
    name: 'creance-conso-reelles',
    components: {
        DateFilter, ManageActionCreanceAssurance
    },
    props: [],
    data() {
        return {
            is_month: false,
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            liste_creances_assurance: [],
            mois_reference: '',
            periode_multi_mois: false,

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },

            fields: [
                { key: 'no', label: 'N°' },
                { key: 'assurance', label: 'Assurance' },
                { key: 'societe', label: 'Société' },
                { key: 'part_assureur', label: 'Consommation réelle' },
                { key: 'forfait', label: 'Forfait mensuel' },
                { key: 'rentabilite', label: 'Rentabilité' },
                { key: 'etat', label: 'État' },
                { key: 'action', label: 'Action.s' }
            ],

            search_filter: "",
            perPage: 25,
            print_per_page: -1,
            currentPage: 1,
            total_pages: 0,

            is_loading: true,
            is_empty: false,
            is_load_error: false,
            selected_facture: {},
            detail_toggler: 0,

            liste_assurances: [],
            liste_societes: [],
            seleted_assurance: null,
            selected_societe: '',
            selected_facture_detail: [],
            is_assurance_bill: true,
            user_info: {},

            // Forfaits mensuels des sociétés (Clinique), indexés par identifiant de société
            forfaits_par_societe: {},
            forfaits_loading: false,
            forfaits_erreur: false
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            if (!this.curr_month || !this.curr_month.id) {
                return
            }
            const data = {
                is_creance: 1,
                is_facture_complementaire: 0,
                month: this.curr_month.id,
                year: this.current_date.getFullYear(),
                libelle_month: this.curr_month.lib,
                one_date: "",
                from_date: "",
                to_date: "",
                assurance_id: this.current_date_filter.assurance_id,
                souscripteur_id: this.current_date_filter.souscripteur_id
            }
            this.current_date_filter = data
            this.is_month = true
            this.currentPage = 1
            this.fetchCreancesConsoReelles()
        },

        seleted_assurance() {
            this.is_assurance_bill = true
            this.selected_societe = ''
            this.fetchSocieteByAssurance()

            this.current_date_filter.assurance_id = (this.seleted_assurance && this.seleted_assurance.id > 0)?this.seleted_assurance.id:null
            this.fetchCreancesConsoReelles()
        },

        selected_societe() {
            this.current_date_filter.souscripteur_id = (this.selected_societe && this.selected_societe.id)?this.selected_societe.id:''
            if (this.current_date_filter.souscripteur_id > 0) {
                this.is_assurance_bill = false
            } else {
                this.is_assurance_bill = true
            }
            this.fetchCreancesConsoReelles()
        },
    },

    computed: {
        assurances() {
            return this.$store.getters["assurances"];
        },

        souscripteurs() {
            return this.$store.getters["souscripteurs"];
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        /**
         * Lignes affichées : consommation de la période, forfait mensuel et qualification de rentabilité
         */
        lignes_consommations() {
            return this.liste_creances_assurance.map((ligne) => {
                const forfait = this.forfaits_par_societe[String(ligne.souscripteur_id)]
                const forfait_mensuel = (forfait && forfait.montant_forfait > 0)?Number(forfait.montant_forfait):null
                // Un forfait est mensuel : sur une période à cheval sur plusieurs mois, la comparaison n'a pas de sens
                const rentabilite = (this.periode_multi_mois)
                    ? { code: 'multi_mois', libelle: 'Période sur plusieurs mois', classe: 'badge-secondary', taux: null, ecart: null }
                    : qualifier_rentabilite(ligne.conso_mois, forfait_mensuel, this.forfaits_erreur)
                return Object.assign({}, ligne, {
                    forfait_mensuel: forfait_mensuel,
                    rentabilite: rentabilite
                })
            })
        },

        libelle_mois_reference() {
            if (!this.mois_reference) {
                return ''
            }
            const index = Number(this.mois_reference.substr(5, 2))
            const mois = (this.list_months && this.list_months[index])?this.list_months[index].lib:''
            return mois + ' ' + this.mois_reference.substr(0, 4)
        }
    },

    mounted() {
        this.user_info = {
            name: this.userCredentials.user.name,
            user_id: this.userCredentials.user.id,
            titre: this.userCredentials.user.titre
        }
        this.initialiser_ecran()
    },

    methods: {
        /**
         * Le forfait est mensuel : l'écran s'ouvre sur le mois courant, pas sur le jour
         */
        initialiser_ecran() {
            this.fetchListAssurances()
            this.charger_forfaits()
            const index_mois = this.current_date.getMonth() + 1
            this.curr_month = (this.list_months && this.list_months[index_mois])?this.list_months[index_mois]:''
        },

        fetchListAssurances() {
            this.liste_assurances = []
            this.$store.dispatch("getAssurances").then(() => {
                const tmp_assur = {
                    id: 0,
                    raison_sociale: "Toutes les assurances"
                }
                this.liste_assurances = [tmp_assur, ...this.assurances]
            })
        },

        fetchSocieteByAssurance() {
            if (this.seleted_assurance == null) {
                this.liste_societes =  []
                return;
            }

            const assurance_id = this.seleted_assurance.id

            if (assurance_id > 0) {
                this.$store.dispatch("getSocieteByAssurance", assurance_id).then(() => {
                    const tmp_societe = {
                        id: 0,
                        souscripteur: "Toutes les sociétés"
                    }
                    this.liste_societes = [tmp_societe, ...this.souscripteurs]
                })
            } else {
                this.liste_societes =  []
            }
        },

        /**
         * Forfaits mensuels lus dans la Clinique (même source que l'onglet Factures Forfaitaires)
         */
        charger_forfaits() {
            this.forfaits_loading = true
            this.forfaits_erreur = false
            return store_assurance.getSouscripteurGroupByAssurance({ a_model_forfait: 1 }).then((response) => {
                const forfaits = {}
                const groupes = Array.isArray(response)?response:[]
                groupes.forEach((groupe) => {
                    const societes = Array.isArray(groupe.souscripteurs)?groupe.souscripteurs:[]
                    societes.forEach((societe) => {
                        forfaits[String(societe.souscripteur_id)] = {
                            montant_forfait: Number(societe.montant_forfait) || 0,
                            prix_unitaire_forfait: Number(societe.prix_unitaire_forfait) || 0,
                            qte_forfait: Number(societe.qte_forfait) || 0,
                            assurance: groupe.raison_sociale,
                            souscripteur: societe.souscripteur
                        }
                    })
                })
                this.forfaits_par_societe = forfaits
                this.forfaits_loading = false
            }).catch(() => {
                this.forfaits_par_societe = {}
                this.forfaits_erreur = true
                this.forfaits_loading = false
            })
        },

        fetchCreancesConsoReelles() {
            this.is_loading = true
            this.is_load_error = false
            this.liste_creances_assurance = []
            return store_operation.getConsommationsForfait(this.current_date_filter).then((response) => {
                this.liste_creances_assurance = response.data
                this.total_pages = response.last_page
                this.mois_reference = response.mois_reference || ''
                this.periode_multi_mois = response.periode_multi_mois === true
                if (this.liste_creances_assurance.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_load_error = true
            })
        },

        filterByDate(date) {
            const data = {
                is_facture_complementaire: 0,
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
                assurance_id: this.current_date_filter.assurance_id,
                souscripteur_id: this.current_date_filter.souscripteur_id
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false
            this.currentPage = 1

            this.fetchCreancesConsoReelles()
        },

        libelle_etat_facture(ligne) {
            if (ligne.facture_forfait && ligne.facture_forfait.etat_libelle) {
                return ligne.facture_forfait.etat_libelle
            }
            return 'en cours'
        },

        classe_etat_facture(ligne) {
            const etat = (ligne.facture_forfait)?Number(ligne.facture_forfait.etat):null
            if (etat === 4) return 'badge-success'
            if (etat === 2 || etat === 3) return 'badge-info'
            return 'badge-warning'
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.current_date_filter.page = this.currentPage
                this.fetchCreancesConsoReelles()
            }
        },

        nextPage() {
            if (this.currentPage < this.total_pages) {
                this.currentPage++;
                this.current_date_filter.page = this.currentPage
                this.fetchCreancesConsoReelles()
            }
        },

        gotoPage(page) {
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.current_date_filter.page = this.currentPage
                this.fetchCreancesConsoReelles()
            }
        },

        async showDetailFactureAssurance(data) {
            this.selected_facture = data
            this.is_assurance_bill = !(data.souscripteur_id > 0)
            // Détail de la société de la ligne, sans modifier le filtre de la liste
            const filtre_detail = Object.assign({}, this.current_date_filter, {
                assurance_id: data.assurance_id,
                souscripteur_id: (data.souscripteur_id > 0)?data.souscripteur_id:''
            })
            await store_operation.getDetailFactureAssuranceSociete(filtre_detail).then((response) => {
                this.selected_facture_detail = response
                this.detail_toggler = (this.detail_toggler == 0)?1:0
                setTimeout(() => {
                    $('.show-detail-bill').modal('show')
                }, 100);
            })
        }
    }
}
